import { render, staticRenderFns } from "./TF3661Component.vue?vue&type=template&id=f79d5200&scoped=true&"
import script from "./TF3661Component.vue?vue&type=script&lang=js&"
export * from "./TF3661Component.vue?vue&type=script&lang=js&"
import style0 from "./TF3661Component.vue?vue&type=style&index=0&id=f79d5200&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79d5200",
  null
  
)

export default component.exports